"use client";

import { createContext } from "react";
import { mergeProps, useHover } from "react-aria";
import { clsx } from "clsx";

export const BlockBentoGridItemContext = createContext<{
  isHovered: boolean;
}>({
  isHovered: false,
});

export function BlockBentoGridItem({ className, ...props }: React.ComponentPropsWithRef<"div">) {
  const { isHovered, hoverProps } = useHover({});

  return (
    <BlockBentoGridItemContext.Provider value={{ isHovered }}>
      <div {...mergeProps(props, hoverProps)} className={clsx("tw-group", className)} />
    </BlockBentoGridItemContext.Provider>
  );
}
